import { render, staticRenderFns } from "./comp_ProductPage-Attributes.vue?vue&type=template&id=36d0c10f&scoped=true&"
import script from "./comp_ProductPage-Attributes.vue?vue&type=script&lang=js&"
export * from "./comp_ProductPage-Attributes.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductPage-Attributes.vue?vue&type=style&index=0&id=36d0c10f&prod&lang=scss&"
import style1 from "./comp_ProductPage-Attributes.vue?vue&type=style&index=1&id=36d0c10f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d0c10f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
